/**
 * Mascara monetária estilo terminal bancário.
 * Recebe uma string de dígitos (ex: "15000") e retorna "R$ 150,00".
 */
export const maskMoney = (digits) => {
  const raw = String(digits || "").replace(/\D/g, "");
  const value = parseInt(raw || "0", 10) / 100;
  return "R$ " + value.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

/**
 * Extrai o valor numérico de uma string mascarada ou de dígitos.
 * Ex: "R$ 150,00" → 150 | "15000" → 150
 */
export const parseMoney = (digits) => {
  const raw = String(digits || "").replace(/\D/g, "");
  return parseInt(raw || "0", 10) / 100;
};

/**
 * Handler de onChange para inputs com máscara monetária.
 * Chama setter apenas com os dígitos (sem formatação).
 */
export const handleMoneyChange = (setter) => (e) => {
  const digits = e.target.value.replace(/\D/g, "");
  setter(digits);
};

/**
 * Divide o total real em centavos, sem adicionar taxas que o backend nao cobra.
 * O Asaas recebe installmentCount + totalValue e ajusta a ultima parcela.
 */
export const cardInstallments = (price) => {
  const cents = Math.round(Number(price) * 100);
  if (!Number.isSafeInteger(cents) || cents <= 0) return [];
  return [1, 2, 3, 4, 6, 12]
    .filter((n) => n <= cents)
    .map((n) => {
      const regularCents = Math.floor(cents / n);
      const lastCents = cents - regularCents * (n - 1);
      return {
        n,
        total: cents / 100,
        installment: regularCents / 100,
        lastInstallment: lastCents / 100,
      };
    });
};
